import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import Context from '@bibliocommons/context';
import { bindAll } from '@bibliocommons/utils-react';
import { userIdentityShape } from '@bibliocommons/bc-prop-types';
import { SecondaryLink } from '@bibliocommons/base-links';
import Divider from '@bibliocommons/divider';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from '@bibliocommons/base-full-screen-overlay';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import TagList from '../TagList';
import AddTags from '../AddTags';

import './AllCommunityTags.scss';

export default class AllCommunityTags extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  renderAddTags() {
    const { currentUser } = this.props;
    const { features } = this.context;

    if (currentUser?.get('staff') && features.get(TOGGLZ_FEATURES.ENABLE_BIB_PAGE_STAFF_TAGGING)) {
      return <AddTags metadataId={this.props.metadataId} tagsActions={this.props.tagsActions} />;
    }
    return null;
  }

  render() {
    return (
      <FullScreenOverlayBody className="cp-all-community-tags">
        <FullScreenOverlayHeader title={<FormattedMessage id="all_community_tags" />} />
        <FullScreenOverlayContent size="small">
          <BibBriefContainer metadataId={this.props.metadataId} />
          {this.renderAddTags()}
          <Divider className="divider" />
          <TagList metadataId={this.props.metadataId} tags={this.props.tags} tagType={SecondaryLink} stacked />
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

AllCommunityTags.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  currentUser: userIdentityShape,
  tagsActions: PropTypes.objectOf(PropTypes.func)
};

AllCommunityTags.contextType = Context;
